import { useContext } from 'react';
import { ReactComponent as KeyboardSvg } from 'assets/keyboard.svg';
import { ReactComponent as CloseSvg } from 'assets/close.svg';
import { ReactComponent as RefreshSvg } from 'assets/refresh.svg';
import styled from 'styled-components';
import Clues from 'components/Clues';
import { InterfaceContext } from 'contexts/InterfaceContext';
import keyboardConstants from 'constants/keyboard';
import Box from 'elements/Box';

const { keys: { ARROWS }} = keyboardConstants;

const ClueBox = styled(Box)(({ theme }) => `
  margin: 1rem auto 0;
  max-width: 40rem;
  padding: 0 1rem;
  width: 100%;
`);
const HomeRow = styled(Box)(({ theme }) => `
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  user-select: none;
`);
const HomeRowButton = styled(Box)(({ theme }) => `
  line-height: calc(${theme.fontSizes.body} * 2);
  font-size: ${theme.fontSizes.big};
  color: ${theme.colors.utility.secondary};
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`);
const KeyboardIcon = styled(KeyboardSvg)(({ theme }) => `
  height: calc(${theme.fontSizes.body} * 2);
  color: ${theme.colors.utility.primary};
`);
const CloseIcon = styled(CloseSvg)(({ theme }) => `
  height: calc(${theme.fontSizes.body} * 1.25);
  line-height: calc(${theme.fontSizes.body} * 2);
`);
const RefreshIcon = styled(RefreshSvg)(({ theme }) => `
  height: calc(${theme.fontSizes.body} * 1.25);
  line-height: calc(${theme.fontSizes.body} * 2);
`);

const Terminal = () => {
  const { toggleKeyboard, handleKeyDown } = useContext(InterfaceContext);

  return (
    <Box>
      <ClueBox onClick={toggleKeyboard}>
        <Clues abridged/>
      </ClueBox>
      <HomeRow>
        <HomeRowButton onClick={toggleKeyboard}>
          <KeyboardIcon />
        </HomeRowButton>
        <HomeRowButton onClick={() => handleKeyDown({ key: 'ArrowLeft' })}>
          {ARROWS.ArrowLeft.display}
        </HomeRowButton>
        <HomeRowButton onClick={() => handleKeyDown({ key: 'ArrowUp' })}>
          {ARROWS.ArrowUp.display}
        </HomeRowButton>
        <HomeRowButton onClick={() => handleKeyDown({ key: 'Enter' })}>
          <RefreshIcon />
        </HomeRowButton>
        <HomeRowButton onClick={() => handleKeyDown({ key: 'ArrowDown' })}>
          {ARROWS.ArrowDown.display}
        </HomeRowButton>
        <HomeRowButton onClick={() => handleKeyDown({ key: 'ArrowRight' })}>
          {ARROWS.ArrowRight.display}
        </HomeRowButton>
        <HomeRowButton onClick={() => handleKeyDown({ key: 'Escape' })}>
          <CloseIcon />
        </HomeRowButton>
      </HomeRow>
    </Box>
  );
}
export default Terminal;
